import {
  COMPANIES_LIST,
  COMPANIES_LIST_SUCCESS,
  COMPANIES_LIST_ERROR,
  COMPANIES_NEW,
  COMPANIES_NEW_SUCCESS,
  COMPANIES_NEW_ERROR,
  COMPANIES_EDIT,
  COMPANIES_DELETE,
  COMPANIES_DELETE_SUCCESS,
  COMPANIES_DELETE_ERROR,
  COMPANIES_IMPORT,
  COMPANIES_IMPORT_SUCCESS,
  COMPANIES_IMPORT_ERROR,
  COMPANIES_IMPORT_ACCOUNTS,
  COMPANIES_IMPORT_ACCOUNTS_SUCCESS,
  COMPANIES_IMPORT_ACCOUNTS_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
  responseNew: "",
  loadingNew: false,
  errorNew: "",
  responseDelete: "",
  loadingDelete: false,
  errorDelete: "",
  loadingImport: false,
  messageImport: "",
  errorImport: "",
  loadingImportAccounts: false,
  messageImportAccounts: "",
  errorImportAccounts: "",
}

const Companies = (state = initialState, action) => {
  switch (action.type) {
    case COMPANIES_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
      }
      break
    case COMPANIES_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case COMPANIES_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    case COMPANIES_NEW:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case COMPANIES_NEW_SUCCESS:
      state = {
        ...state,
        loadingNew: false,
        responseNew: action.payload.data
      }
      break
    case COMPANIES_NEW_ERROR:
      state = {
        ...state,
        loadingNew: false,
        errorNew: action.payload
      }
      break
    case COMPANIES_EDIT:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case COMPANIES_DELETE:
      state = {
        ...state,
        loadingDelete: true,
        responseDelete: "",
        errorDelete: ""
      }
      break
    case COMPANIES_DELETE_SUCCESS:
      state = {
        ...state,
        loadingDelete: false,
        responseDelete: action.payload.data
      }
      break
    case COMPANIES_DELETE_ERROR:
      state = {
        ...state,
        loadingDelete: false,
        errorDelete: action.payload
      }
      break
    case COMPANIES_IMPORT:
      state = {
        ...state,
        loadingImport: true,
        messageImport: "",
        errorImport: "",
        messageImportAccounts: "",
        errorImportAccounts: "",
      }
      break
    case COMPANIES_IMPORT_SUCCESS:
      state = {
        ...state,
        loadingImport: false,
        messageImport: action.payload.data.message,
      }
      break
    case COMPANIES_IMPORT_ERROR:
      state = {
        ...state,
        loadingImport: false,
        errorImport: action.payload,
      }
      break
    case COMPANIES_IMPORT_ACCOUNTS:
      state = {
        ...state,
        loadingImportAccounts: true,
        messageImport: "",
        errorImport: "",
        messageImportAccounts: "",
        errorImportAccounts: "",
      }
      break
    case COMPANIES_IMPORT_ACCOUNTS_SUCCESS:
      state = {
        ...state,
        loadingImportAccounts: false,
        messageImportAccounts: action.payload.data.message,
      }
      break
    case COMPANIES_IMPORT_ACCOUNTS_ERROR:
      state = {
        ...state,
        loadingImportAccounts: false,
        errorImportAccounts: action.payload,
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default Companies
